import { Button, Form, Input, Modal } from "antd";
import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { CONFIG } from "../../environment";
import { store } from "../../store";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function ForcePassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [seconds, setSeconds] = useState(0);
  const [otp, setOtp] = useState("");
  const [verifyDetails, setVerifyDetails] = useState({});
  const [successVisible, setSuccessVisible] = useState(false);
  const [message, setMessage] = useState("");
  const { t } = useTranslation();

  const onFinish = useCallback(async (values) => {
    try {
      const response = await AuthService.forceChangePasswordVerify({
        newPassword: values?.newPassword,
        currentPassword: location?.state?.password,
      });
      if (response.status === 200) {
        setVerifyDetails(response.data["data"]);
        if (response.data["otpEnable"] === false) {
          forceChangePasswordConfirm({ ...values, otp: CONFIG.DEFAULT_OTP });
        } else {
          navigate("/forcechange-otp", {
            state: {
              newPassword: values?.newPassword,
              currentPassword: location?.state?.password,
              ...response.data,
            },
          });
        }
      }
    } catch (error) {}
  }, []);

  const forceChangePasswordConfirm = useCallback(async (values) => {
    try {
      const response = await AuthService.forceChangePasswordConfirm({
        newPassword: values?.newPassword,
        currentPassword: location?.state?.password,
        otp: values.otp,
      });
      if (response.status === 200) {
        setSeconds(0);
        setSuccessVisible(true);
        setMessage(response.data["message"]);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  return (
    <>
      <div className="h-100 px-5">
        <div align="center" className="mb-4">
          <img src={BANK_LOGO} height={35} />
        </div>
        <PerfectScrollbar>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <h3 align="" className="mb-4 password-text">
              {t("pages.forcePassword.force_change_password_title", {
                defaultValue: "Force Change Password",
              })}
            </h3>

              <Form
                name="ChangePassordForm"
                layout="vertical"
                requiredMark={true}
                onFinish={onFinish}
                style={{ width: "80%" }}
              >
                 {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {" "}
                <Form.Item
                  label={"Current Password"}
                  name="currentPassword"
                  rules={[
                    {
                      required: true,
                      message: "Current Password is required",
                    },
                  ]}
                >
                  <Input.Password
                    maxLength={20}
                    size="large"
                    placeholder={"Current Password"}
                  />
                </Form.Item>
              </div> */}

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {" "}
                <Form.Item
                  label={
                    <>
                      {t("pages.forcePassword.new_password", {
                        defaultValue: "New Password",
                      })}
                    </>
                  }
                  name="newPassword"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.new_password_required", {
                        defaultValue: "New Password is required",
                      }),
                    },
                    {
                      pattern: new RegExp(
                        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#&*!])[A-Za-z\d@#&*!]{8,}$/
                      ),
                      message: t("errorMesssages.new_password_criteria", {
                        defaultValue:
                          "New Password should match Password Criteria!",
                      }),
                    },
                  ]}
                >
                  <Input.Password
                    maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                    size="large"
                    placeholder={t("pages.forcePassword.new_password", {
                      defaultValue: "New Password",
                    })}
                    minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                  />
                </Form.Item>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                {" "}
                <Form.Item
                  label={t("pages.forcePassword.confirm_new_password", {
                    defaultValue: "Confirm New Password",
                  })}
                  name="confirmNewPassword"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "errorMesssages.confirm_new_password_required",
                        {
                          defaultValue: "Confirm New Password is required",
                        }
                      ),
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          t("errorMesssages.password_do_not_match", {
                            defaultValue: "Passwords do not match!",
                          })
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                    size="large"
                    placeholder={t("pages.forcePassword.confirm_new_password", {
                      defaultValue: "Confirm New Password",
                    })}
                    minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                  />
                </Form.Item>
              </div>
                <div align="center">
                  <Button
                    block
                    size="large"
                    className="login-button mt-2"
                    type="primary"
                    htmlType="submit"
                  >
                    {t("buttons.submit_btn", {
                      defaultValue: "Submit",
                    })}
                  </Button>
                  <Button
                  onClick={() => {
                    //store.dispatch({ type: "USER_LOGOUT" });
                    navigate("/login");
                  }}
                  block
                  type="link"
                  size="large"
                  className="mt-3"
                >
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>
                </div>
              </Form>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div className="password-criteria">
              <h5 className="password-text" style={{ fontSize: "20px" }}>
                {t("pages.changePassword.tips", {
                  defaultValue: "New Password Criteria Tips",
                })}
              </h5>
              <div
                className="change-list text-start"
                style={{ fontSize: "15px" }}
              >
                <ul className="my-3 mx-3 ">
                  <li className="mb-2">
                    {t("pages.changePassword.Password_length", {
                      defaultValue:
                        "Password length should not be less than 6 and not more than 16 characters.",
                    })}
                  </li>
                  <li className="mb-2">
                    {t("pages.changePassword.password_allow", {
                      defaultValue:
                        "Password should contain at least one digit [0-9], one alphabet [A-Z] [a-z] and one special character such as  [@#&*!].",
                    })}
                  </li>
                  <li className="mb-2">
                    {t("pages.changePassword.password_avoid", {
                      defaultValue:
                        "Please avoid choosing a password that is generic in nature, guessable or inferable.",
                    })}
                  </li>
                  <li className="mb-2">
                    {t("pages.changePassword.password_avoid_relate", {
                      defaultValue:
                        "Avoid password that is related to your personal data such as name, date of birth, address, telephone number and car or bike registration number.",
                    })}
                  </li>
                  <li className="mb-2">
                    {t("pages.changePassword.password_memorize", {
                      defaultValue:
                        "It is a good practice to memorize your password rather than write it down somewhere.",
                    })}
                  </li>
                  <li>
                    {t("pages.changePassword.security_reasons", {
                      defaultValue:
                        "For security reasons, keep changing your password at regular intervals.",
                    })}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          </div>{" "}
          </PerfectScrollbar>
      </div>

      <Modal
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{   margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                navigate("/login");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
